import { render, staticRenderFns } from "./sessionResults.vue?vue&type=template&id=2844b6be"
import script from "./sessionResults.vue?vue&type=script&lang=js"
export * from "./sessionResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports